import { FirestoreBankAccountRepository } from "../../../infrastructure/repositories/BankAccountRepository";
import { FirestoreUserBankRepository } from "../../../infrastructure/repositories/UserBankRepository";
import { AppUserId } from "../../types/AppUser";
import { PlaidLinkOnSuccessMetadata } from "react-plaid-link";
import {
  createBankAccountsFromPlaidMetadata,
  createUserBankFromPlaidMetadata,
} from "../../factories/UserBankFactory";
import { FirestoreAppUserRepository } from "../../../infrastructure/repositories/appUserRepository";

export class BankLinkingService {
  private appUserRepository: FirestoreAppUserRepository;
  private bankAccountRepository: FirestoreBankAccountRepository;
  private userBankRepository: FirestoreUserBankRepository;

  constructor(
    appUserRepository: FirestoreAppUserRepository,
    bankAccountRepository: FirestoreBankAccountRepository,
    userBankRepository: FirestoreUserBankRepository,
  ) {
    this.appUserRepository = appUserRepository;
    this.bankAccountRepository = bankAccountRepository;
    this.userBankRepository = userBankRepository;
  }

  async handlePlaidSuccess(
    appUserId: AppUserId,
    plaidMetadata: PlaidLinkOnSuccessMetadata,
  ): Promise<void> {
    const userBank = createUserBankFromPlaidMetadata(appUserId, plaidMetadata);
    const bankAccounts = createBankAccountsFromPlaidMetadata(
      userBank.userBankId,
      appUserId,
      userBank.bankId,
      plaidMetadata.accounts,
    );

    await this.userBankRepository.create(userBank);

    for (const account of bankAccounts) {
      await this.bankAccountRepository.create(account);
      await this.appUserRepository.addUserBankAccount(
        appUserId,
        userBank.userBankId,
        account.accountId,
      );
    }
  }
}
